import React from "react";
import { Link } from "react-router-dom";

const AdvertisingAgent = (props) => {
  return (
    <section
      id="id_ico_about_section"
      className={`ico_about_section section_space section_decoration bg-white ${props.abClass}`}
    >
      <div className="container">
        <div className="row justify-content-lg-between">
          <div className="col-lg-12">
            <h5 className="title_text text-dark">TopCoin UK Agents</h5>
            <p className="text-dark opacity-75">
              TopCoin UK Agents help expand the TopCoin UK platform network by introducing customers and participating businesses to the TopCoin UK loyalty ecosystem.
            </p>
            <p className="text-dark opacity-75">
              Participation as an agent is free and available to eligible TopCoin UK members.
            </p>
            <p className="text-dark opacity-75">
              TopCoin UK operates as a technology-driven loyalty and advertising platform designed to connect customers and businesses through a structured participation network.
            </p>

            <h5 className="title_text text-dark">1. TopCoin Ecosystem Definition</h5>
            <p className="text-dark opacity-75">
              The TopCoin UK ecosystem is a digital loyalty participation network that connects customers and businesses through the TopCoin UK platform.
            </p>
            <p className="text-dark opacity-75">
              Within this ecosystem, TopCoin is used as platform recognition that reflects customer participation, shopping activity, and engagement within the platform.
            </p>
            <p className="text-dark opacity-75">
              TopCoin operates exclusively within the TopCoin UK platform environment and does not represent money, financial assets, securities, investment instruments, or transferable financial products.
            </p>
            <p className="text-dark opacity-75">
              All TopCoin recognition generated within the TopCoin UK ecosystem exists solely within the operational framework of the TopCoin UK platform.
            </p>

            <h5 className="title_text text-dark">2. Turn Everyday Participation into TopCoin Recognition</h5>
            <p className="text-dark opacity-75">
              Becoming a TopCoin UK Agent allows members to share the platform with others and participate in the growth of the TopCoin UK community.
            </p>
            <p className="text-dark opacity-75">
              Where customers and retailers participate in the platform and generate TopCoin through normal shopping activity with participating businesses, the platform may record Agent TopCoin recognition linked to that activity according to the operational rules of the TopCoin UK platform.
            </p>
            <p className="text-dark opacity-75">
              Recognition forms part of the TopCoin UK advertising and loyalty programme and reflects participation within the platform network.
            </p>

            <h5 className="title_text text-dark">3. Platform Participation Principle</h5>
            <p className="text-dark opacity-75">
              TopCoin UK operates as a participation-based loyalty ecosystem connecting customers and businesses through the TopCoin UK platform network.
            </p>
            <p className="text-dark opacity-75">
              TopCoin represents loyalty recognition linked to customer shopping activity and participation within the platform.
            </p>
            <p className="text-dark opacity-75">
              TopCoin does not represent money, investments, financial returns, interest, securities, or financial instruments.
            </p>
            <p className="text-dark opacity-75">
              All TopCoin recognition within the platform — including customer rewards, bonus wallets, Advertising Agent recognition, and Retail Agent recognition — is generated solely through participation within the TopCoin UK loyalty ecosystem.
            </p>

            <h5 className="title_text text-dark">4. Platform Participation Clarification</h5>
            <p className="text-dark opacity-75">
              Participation as a TopCoin UK Agent is intended solely to support the growth of the TopCoin UK platform community.
            </p>
            <p className="text-dark opacity-75">
              Agents may introduce customers or businesses to the platform, but recognition within the platform is linked to genuine platform activity and customer participation, not recruitment alone.
            </p>
            <p className="text-dark opacity-75">
              TopCoin UK does not operate as a multi-level marketing programme, investment programme, or commission-based referral scheme.
            </p>

            <h5 className="title_text text-dark">5. Advertising Agents</h5>
            <p className="text-dark opacity-75">
              Advertising Agents introduce customers to the TopCoin UK platform.
            </p>
            <p className="text-dark opacity-75">
              When customers introduced by an Advertising Agent participate in the platform and collect TopCoin through normal shopping activity with participating businesses, the platform may record Advertising Agent TopCoin recognition linked to that activity according to platform operational rules.
            </p>
            <p className="text-dark opacity-75">
              Recognition is linked to genuine customer participation within the platform network.
            </p>
            <p className="text-dark opacity-75">
              Advertising Agent TopCoin recognition is recorded separately from customer TopCoin balances and customer reward wallets.
            </p>

            <h5 className="title_text text-dark">6. Retail Agents</h5>
            <p className="text-dark opacity-75">
              Retail Agents introduce shops and retail businesses to the TopCoin UK platform.
            </p>
            <p className="text-dark opacity-75">
              Participating retailers may choose to provide TopCoin and bonus recognition to their customers as part of their loyalty promotions.
            </p>
            <p className="text-dark opacity-75">
              Where retailers introduced by a Retail Agent generate customer shopping activity within the platform, the platform may record Retail Agent TopCoin recognition and bonus recognition linked to that activity according to platform operational rules.
            </p>
            <p className="text-dark opacity-75">
              Recognition remains linked to genuine customer shopping activity within the platform network.
            </p>

            <h5 className="title_text text-dark">7. Example of Platform Recognition</h5>
            <p className="text-dark opacity-75">
              As participation grows within the platform network, recognition milestones may be recorded for agents according to platform operational rules.
            </p>
            <p className="text-dark opacity-75">
              For example, when a total of 20,000 TopCoin are recorded through activity generated within an agent's network, the platform may allocate recognition value to the Agent Reward Wallet, subject to platform rules and eligibility conditions.
            </p>

            <h5 className="title_text text-dark">8. Why Become a TopCoin UK Agent</h5>
            <ul>
              <li className="text-dark opacity-75">Help introduce customers and businesses to the TopCoin UK platform</li>
              <li className="text-dark opacity-75">Support local businesses through a loyalty participation system</li>
              <li className="text-dark opacity-75">Participate in the growth of a global platform network</li>
              <li className="text-dark opacity-75">Recognition linked to verified customer activity</li>
              <li className="text-dark opacity-75">No investment required</li>
              <li className="text-dark opacity-75">Free to participate</li>
            </ul>

            <h5 className="title_text text-dark">9. How the Agent Programme Works</h5>
            <p className="text-dark opacity-75">
              Join the TopCoin UK platform as a customer.
            </p>
            <p className="text-dark opacity-75">
              Share the platform with customers or businesses who may benefit from participating.
            </p>
            <p className="text-dark opacity-75">
              Apply to participate as an Advertising Agent or Retail Agent.
            </p>
            <p className="text-dark opacity-75">
              As customers and retailers participate in the platform and generate TopCoin through shopping activity, the platform may record Agent TopCoin recognition linked to that activity according to platform rules.
            </p>

            <h5 className="title_text text-dark">10. Participation Eligibility</h5>
            <p className="text-dark opacity-75">
              Agent participation is available to eligible TopCoin UK members.
            </p>
            <p className="text-dark opacity-75">
              Members aged 16–17 may participate with parental or guardian consent according to TopCoin UK safeguarding policies.
            </p>
            <p className="text-dark opacity-75">
              TopCoin UK Ltd may review or approve agent participation where necessary to ensure responsible platform development.
            </p>

            <h5 className="title_text text-dark">11. Platform Rules</h5>
            <p className="text-dark opacity-75">
              Agent recognition is recorded according to the operational rules of the TopCoin UK platform.
            </p>
            <p className="text-dark opacity-75">
              TopCoin UK Ltd reserves the right to review, adjust, update, or modify platform operational rules and recognition structures where necessary to maintain the stability and development of the platform.
            </p>

            <h5 className="title_text text-dark">12. No Guaranteed Rewards</h5>
            <p className="text-dark opacity-75">
              TopCoin recognition recorded within the platform is not guaranteed and may vary depending on platform participation levels, customer activity, and retailer participation.
            </p>
            <p className="text-dark opacity-75">
              TopCoin UK does not guarantee income, profits, or financial returns to agents.
            </p>

            <h5 className="title_text text-dark">13. Important Compliance Notice</h5>
            <p className="text-dark opacity-75">
              TopCoin and agent recognition are part of a loyalty and promotional participation programme.
            </p>
            <p className="text-dark opacity-75">
              TopCoin:
              <br />
              * is not money
              <br />
              * is not an investment
              <br />
              * does not represent financial returns
              <br />
              * does not represent commission or profit-sharing schemes
            </p>
            <p className="text-dark opacity-75">
              TopCoin recognition exists solely within the TopCoin UK platform ecosystem.
            </p>

            <h5 className="title_text text-dark">14. Platform Authority</h5>
            <p className="text-dark opacity-75">
              The TopCoin UK platform structure, systems, technology, loyalty mechanisms, and operational rules remain the exclusive property of TopCoin UK Ltd.
            </p>
            <p className="text-dark opacity-75">
              Participation as an Advertising Agent or Retail Agent does not grant ownership rights in the platform or its network.
            </p>

            <h5 className="title_text text-dark">15. Global Platform Clause</h5>
            <p className="text-dark opacity-75">
              Participation within the TopCoin UK platform constitutes participation within a private promotional loyalty ecosystem operated by TopCoin UK Ltd.
            </p>
            <p className="text-dark opacity-75">
              All TopCoin recognition, loyalty mechanisms, and participation systems operate solely within the TopCoin UK platform environment.
            </p>

            <h5 className="title_text text-dark">16. TopCoin UK Platform Network</h5>
            <p className="text-dark opacity-75">
              TopCoin UK is designed to grow through customer participation, retailer engagement, and community expansion.
            </p>
            <p className="text-dark opacity-75">
              Through the TopCoin UK platform network, customers and businesses connect within a structured loyalty ecosystem that recognises participation and supports business growth.
            </p>

            {/* NEW CARD SECTION */}
            <div className="d-flex justify-content-center my-5">
              <div
                className="card shadow-sm border-0"
                style={{ maxWidth: "1000px", width: "100%" }}
              >
                <div className="card-body text-center">
                  <h5
                    className="mt-4 mb-4"
                    data-aos="fade-up"
                    data-aos-duration="800"
                  >
                    What Happens After You Join?
                  </h5>

                  <p
                    className="card-text mb-4 ps-3 pe-3 opacity-75"
                    data-aos="fade-up"
                    data-aos-duration="800"
                  >
                    Once you join as a customer, you can start inviting others.
                    After you have referred new customers, you can apply to
                    become an Advertising Agent and unlock rewards as your
                    network grows.
                  </p>

                  <ul
                    className="opacity-75 ms-3 ps-5 pe-5 text-start"
                    style={{ display: "inline-block" }}
                    data-aos="fade-up"
                    data-aos-duration="800"
                  >
                    <li className="mb-3">
                      <strong>Step 1 – Join as a Customer: </strong>
                      Click the button to create your account instantly.
                    </li>
                    <li className="mb-3">
                      <strong>Step 2 – Invite New Customers: </strong>
                      After joining, share your referral link and invite family
                      and friends to join Topcoin UK.
                    </li>
                    <li className="mb-3">
                      <strong>Step 3 – Request for Advertising Agent: </strong>
                      Once you have invited customers, submit your request to
                      become an Advertising Agent.
                    </li>
                    <li className="mb-3">
                      <strong>Step 4 – Start Earning: </strong>
                      Earn rewards every time your invited customers join and
                      shop.
                    </li>
                  </ul>

                  <div className="mt-3 mb-5">
                    <Link className="ico_creative_btn" to="/sign_up">
                      <span className="btn_wrapper px-5 py-0">
                        <span className="btn_label">Join Now</span>
                        <span className="btn_icon_right">
                          <svg
                            xmlns="http://www.w3.org/2000/svg"
                            viewBox="0 0 24 24"
                            width="24"
                            height="24"
                            fill="currentColor"
                          >
                            <path d="M16.0037 9.41421L7.39712 18.0208L5.98291 16.6066L14.5895 8H7.00373V6H18.0037V17H16.0037V9.41421Z"></path>
                          </svg>
                        </span>
                      </span>
                    </Link>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
};

export default AdvertisingAgent;